import { useJsApiLoader } from '@react-google-maps/api';
import type { Libraries } from '@react-google-maps/api';
import { useCallback, useState } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { NewLeadForm } from '.';

export const GOOGLE_MAP_LIBRARIES: Libraries = ['places'];

export const useInjection = (setValue?: UseFormSetValue<NewLeadForm>) => {
  const [autocomplete, setAutocomplete] = useState<google.maps.places.Autocomplete | null>(null);

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    libraries: GOOGLE_MAP_LIBRARIES,
    googleMapsApiKey: process.env.REACT_APP_MAP_KEY!
  });

  return {
    isLoaded,
    onPlaceChanged: useCallback(() => {
      if (!setValue) return;
      if (autocomplete !== null) {
        const place = autocomplete?.getPlace();
        const postalCode = place?.address_components
          ?.filter(function (it) {
            return it.types.indexOf('postal_code') != -1;
          })
          .map(function (it) {
            return it.long_name;
          });
        const city = place?.address_components?.find(
          (item) =>
            item.types.includes('administrative_area_level_2') || item.types.includes('locality')
        );
        const province = place?.address_components?.find((item) =>
          item.types.includes('administrative_area_level_1')
        );
        if (city) setValue('city', city.long_name);
        if (postalCode?.length) {
          setValue('postalCode', postalCode[0]);
        } else {
          setValue('postalCode', '');
        }
        if (province) setValue('province', province.long_name);
        if (place.geometry?.location?.lat()) setValue('latitude', place.geometry?.location?.lat());
        if (place.geometry?.location?.lng()) setValue('longitude', place.geometry?.location?.lng());
      } else {
        console.log('Autocomplete is not loaded yet!');
      }
    }, [autocomplete, setValue]),
    onLoadAutoComplete: useCallback((autocompleteInstance: google.maps.places.Autocomplete) => {
      setAutocomplete(autocompleteInstance);
    }, [])
  };
};
